import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { GroupEntity, RightEntity } from './definitions.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuardService implements CanActivate {
  constructor(public router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    // this will be passed from the route config
    // on the data property
    const expectedRole: GroupEntity[] = route.data.expectedRole;
    const expectedRights: RightEntity[] = route.data.expectedRights;
    var hasAccess = this.authService.hasRightToAccess(expectedRole, expectedRights, route);
    return hasAccess;
  }
}
